const templateUrl = require('./views/one-time-differences-warnings.html');

const app = angular.module('msi.products.oneTimeDifferences.oneTimeDifferencesWarnings', [
  require('./one-time-differences-warning.controller')
]);

app.component('ogOneTimeDifferencesWarnings', {
  bindings: {
    shipment: '=ogFor'
  },
  templateUrl: templateUrl,
  controller: 'oneTimeDifferencesWarningsController'
});

module.exports = app.name;
